<template>
  <span :is="email && !src ? 'Gravatar' : 'img'" class="logo" :class="{inline, square}" :email="email" :src="newSrc" :alt="newAlt" :title="newTitle" />
</template>

<script>
  import Gravatar from 'vue-gravatar'
  import objects from '@/objects'
  import logos from '@/logos'

  export default {
    name: 'Logo',
    components: {
      Gravatar
    },
    props: {
      email: {
        type: String,
        required: false,
      },
      src: {
        type: String,
        required: false,
      },
      entity: {
        type: Object,
        required: false,
      },
      providerType: {
        type: String,
        required: false,
      },
      serviceType: {
        type: String,
        required: false,
      },
      alt: {
        type: String,
        required: false,
      },
      title: {
        type: String,
        required: false,
      },
      inline: {
        type: Boolean,
        required: false,
      },
      square: {
        type: Boolean,
        required: false,
      },
    },
    computed: {
      providersByType() {
        return objects._providersByType
      },
      servicesByType() {
        return objects._servicesByType
      },
      newSrc() {
        if (this.src) {
          return this.src
        }
        if (this.entity) {
          return this.entity._logo || logos.unknown
        }
        if (this.providerType) {
          return this.providersByType[this.providerType]._logo
        }
        if (this.serviceType) {
          return this.servicesByType[this.serviceType]._logo
        }
        return null
      },
      newAlt() {
        return this.alt || ''
      },
      newTitle() {
        if (this.title) {
          return this.title
        }
        if (this.entity) {
          switch (this.entity.target) {
            case 'provider': return this.providersByType[this.entity.type].providerTitle
            case 'host': return this.providersByType[this.entity.providerType].providerTitle
            case 'service': return this.servicesByType[this.entity.type].typeTitle
            case 'container': return this.servicesByType[this.entity._service.type].typeTitle
          }
          return 'Unknown'
        }
        return ''
      },
    },
  }
</script>

<style scoped>
  .inline { height: 1.2em; margin: -.2em .2em -.2em 0; }
  .square { width: 1.2em; object-fit: contain; }
</style>
